// Current metadata keys
let metadata_definitions = [
    {key: "aliases", label: "Alias Names", type: "string"},
    {key: "colors", label: "Available Colors", type: "string"},
    {key: "laser_settings", label: "Laser Settings", type: "string"},
    {key: "placement_options", label: "Engraving Placement Options", type: "string"},
    {key: "design_options", label: "Font/Design Options", type: "string"},
    {key: "platforms", label: "Platforms", type: "string"},
    {key: "pricing", label: "Pricing", type: "string", size: "large"},
    {key: "notes", label: "Notes", type: "string", size: "large"},
    {key: "amazon_msku", label: "Amazon SKU (legacy)", type: "string", hidden: true},
    {key: "auto_threshold", label: "Automatic threshold", type: "int,float", hidden: true},
    {key: "box", label: "Packing box (legacy)", type: "string", hidden: true},
    {key: "cut", label: "CNC Cut data", type: "string", hidden: true},
    {key: "width", label: "Width (in)", type: "float", group: "Dimensions"},
    {key: "height", label: "Height (in)", type: "float", group: "Dimensions"},
    {key: "depth", label: "Depth (in)", type: "float", group: "Dimensions"},
    {key: "giftplate", label: "Gift plate tray", type: "string", hidden: true},
    {key: "inventory", label: "Inventory sideload", type: "string"},
    {key: "location", label: "Storage location", type: "string"},
    {key: "manual_threshold", label: "Manual threshold", type: "int", hidden: true},
    {key: "material", label: "Material", type: "string", control: "select", options:["bamboo", "leather", "acrylic", "other"]},
    {key: "sideload", label: "Sideload (legacy)", type: "string"},
    {key: "sku", label: "SKU (legacy)", type: "string"},
    {key: "swappable", label: "Swappable with SKU", type: "string"},
    {key: "tray", label: "Tray (legacy)", type: "string"},
    {key: "web_enabled", label: "Web-enabled", type: "string", control: "switch"},
    {key: "web_options", label: "Web options", type: "string", size:"large"},
    {key: "web_front_only", label: "Web: only show front", type: "int", control: "switch"},
    {key: "weight", label: "Weight (oz)", type: "float"},
    {key: "location", label: "Shelf Location", type: "string"}
];

let lcc_custom_definitions = [
    {group: "Raised panel", key: "panel_profile", label: "Panel profile", type: "string", control: "select", source: "toolprofiles_panel"},
    {group: "Raised panel", key: "panel_inset", label: "Panel inset (in)", type: "string"},
    {group: "Geometry", key: "arch_distance", label: "Arch height (in)", type: "string"},
];

let metadata_defaults = {
    key: "none",
    label: "unnamed",
    type: "string",
    size: "normal",
    control: "default",
    hidden: false,
    defaultString: null,
    defaultInt: null,
    defaultFloat: null,
    group: null
};

let base_metadata_by_key = Object.fromEntries(metadata_definitions.map((meta) => [meta.key, meta]));
let lcc_metadata_by_key = Object.fromEntries(lcc_custom_definitions.map((meta) => [meta.key, meta]));
let metadata_by_key = {...base_metadata_by_key, ...lcc_metadata_by_key};

function metadataOptions(dataset, exclude=[]) {
    let ret = [];
    var metadata_set = metadata_definitions;
    if (dataset === "lcc_custom") metadata_set = lcc_custom_definitions;
    metadata_set.forEach(definition => {
        if(exclude.indexOf(definition.key) === -1) {
            ret.push(definition);
        }
    })
    return ret;
}

function metadataOption(key) {
    return {...metadata_defaults, ...metadata_by_key[key]};
}

export { metadataOptions, metadataOption }
